import script from "./rohsDeclarationFormList.vue?vue&type=script&setup=true&lang=js"
export * from "./rohsDeclarationFormList.vue?vue&type=script&setup=true&lang=js"

import "./rohsDeclarationFormList.vue?vue&type=style&index=0&id=6b800cb4&lang=scss"

const __exports__ = script;

export default __exports__